<template>
  <v-row justify="center">
    <v-dialog v-model="showDialog" persistent max-width="700">
      <v-card>
        <v-card-title class="headline" v-bind:style="{ backgroundColor: '#1e345d', color: 'white'}">Add Document Type
          <v-spacer></v-spacer>
          <v-btn color="white" icon @click="toggleDialog(), newDocumentType= {}"><v-icon>close</v-icon></v-btn>
        </v-card-title>
        <v-container>
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-text-field label="Name"
                            :rules="[rules.exists]"
                            v-model="newDocumentType.name">
              </v-text-field>

              <v-text-field label="Description"
                            v-model="newDocumentType.description">
              </v-text-field>

            </v-col>
          </v-row>
          <div v-if="disabled" class="text-center">
            Saving<br />
            <v-progress-circular indeterminate
                                 color="success"
                                 v-if="disabled"></v-progress-circular>
          </div>
          <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn block depressed color="accent" @click="createDocumentType" :disabled="disabled">Add</v-btn>
          </v-card-actions>
          <v-alert v-if="this.error != null || this.ruleError != null" dismissible color="error" dark>
            <v-icon size="20" dark>warning</v-icon>{{this.error}} {{this.ruleError}}
          </v-alert>
        </v-container>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  props: {
    showDialog: {
      type: Boolean,
      required: true
    },
    toggle: {
      type: Function,
      required: true
    }
  },
  data () {
    return {
      newDocumentType: {
        name: null,
        description: null,
        slug: null
      },
      rules: {
        exists: value => !this.exists(this.slugify(value)) || 'This Document Type Name already exists.'
      },
      disabled: false,
      ruleError: null
    }
  },
  methods: {
    ...mapActions({
      create: 'documentType/createDocumentType',
      clearErrors: 'documentType/clearErrors'
    }),
    toggleDialog () {
      this.ruleError = null
      this.clearErrors()
      this.toggle()
    },
    async createDocumentType () {
      this.clearErrors()
      this.disabled = true

      if (this.newDocumentType.name) {
        this.newDocumentType.slug = this.slugify(this.newDocumentType.name)
      }

      if (this.exists(this.newDocumentType.slug)) {
        this.ruleError = 'Duplicates cannot be added, this document type may be archived'
      } else {
        await this.create(this.newDocumentType)
        if (!this.error) {
          this.toggle()
        }
        this.newDocumentType = {}
      }

      this.disabled = false
    },
    exists (value) {
      var exist = false

      this.slugs.forEach((slug) => {
        if (slug.text === value) {
          exist = true
        }
      })

      return exist
    },
    slugify (name) {
      if (name === undefined || name === null) {
        return name
      } else {
        return name.replace(/\s+/g, '-').toLowerCase()
      }
    }
  },
  computed: {
    ...mapGetters({
      documentTypes: 'documentType/types',
      slugs: 'documentType/slugs',
      error: 'documentType/error'
    })
  }
}
</script>
